





















































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { IOffer } from "@/store/interfaces/offer";
import { addGoal, EGoal } from "@/services/addYGoal.ts";
import { mapGetters } from "vuex";

@Component({
  name: "OfferCard",
  computed: mapGetters("products", ["getIsFiltering"])
})
export default class OfferCard extends Vue {
  @Prop({ default: null })
  offer: IOffer;

  loading: boolean = true;
  isLoadText: boolean = false;
  elepsize: boolean = false;

  checkCurrency(currency) {
    return { USD: "$", GBP: "£", EUR: "€", BRL: "R$" }[currency] || currency;
  }

  textElepsise() {
    let heading: any = this.$refs["heading"];
    if (!heading) return;
    let desk: any = this.$refs["desk"];
    let i: number = 0;
    if (heading.innerHTML.length > 60) {
      heading.innerHTML = heading.innerHTML.slice(0, 60);
    }

    while (parseInt(window.getComputedStyle(heading).height, 10) > 35) {
      this.isLoadText = false;
      i++;
      heading.innerHTML = heading.innerHTML
        .slice(0, 60 - i)
        .replace(/\W*\s(\S)*$/, "...");

      if (heading.innerHTML.indexOf("...") !== -1) {
        heading.classList.add("elepsis");
        this.elepsize = true;
      }
    }

    if (desk.innerHTML.length > 60) {
      desk.innerHTML = desk.innerHTML.slice(0, 60);
    }
    i = 0;
    while (parseInt(window.getComputedStyle(desk).height, 10) > 35) {
      i++;
      this.isLoadText = false;
      desk.innerHTML = desk.innerHTML
        .slice(0, 60 - i)
        .replace(/\W*\s(\S)*$/, "...");
    }

    this.$emit("ready", "text");
    this.isLoadText = true;
  }

  updated() {
    this.textElepsise();
  }

  mounted() {
    this.textElepsise();
  }

  priceClass() {
    return {
      long: this.offer.price.length > 11,
      "too-long": this.offer.price.length > 17
    };
  }

  async handleOfferClick(url) {
    await addGoal(EGoal.offer_click);
    window.open(url, "_blank");
  }

  @Watch("getIsFiltering")
  onGetIsFilteringChanged(value) {
    if (!value) {
      this.textElepsise();
    }
  }
}
